import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

console.log(`Build details:  ${process.env.REACT_APP_BUILD_NUMBER}`);
ReactDOM.render(<App />, document.getElementById('root'));
